import { useSelector } from 'react-redux';

const usePermissions = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  return permissions;
};

export default usePermissions;
